export default __webpack_public_path__ + "static/media/questions-coin.8891ef5d.png";